module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/resonio/startpage_en-5d2bae5f79e89aa42c6518aa46af0b91.gif";